import { adminAPIURL, labAPIURL, cianacareApi, deleteactapis ,generateReportUrl} from './httpHeaderInterceptor';

export async function getAllTestsForGeneticProgramAPI(searchText) {


    try {
        const response = await adminAPIURL.get('longevityGeneticWellness/getAllTestsForGeneticProgram?searchText=' + searchText);
        const getAllTestsForGeneticProgramData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('getAllTestsForGeneticProgramData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return getAllTestsForGeneticProgramData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function createProgramAPI(requestObj) {


    try {
        const response = await adminAPIURL.post('longevityGeneticWellness/createProgram', requestObj);
        const createProgramData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('createProgramData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return createProgramData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function addDiagnosticCenterAPI(requestObj) {


    try {
        const response = await adminAPIURL.post('diagnosticCenter/addDiagnosticCenter', requestObj);
        const addDiagnosticCenterData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('addDiagnosticCenterData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return addDiagnosticCenterData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function getAllDiagnosticCentersAPI() {


    try {
        const response = await adminAPIURL.get('diagnosticCenter/getAllDiagnosticCenters');
        const getAllDiagnosticCentersData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('getAllDiagnosticCentersData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return getAllDiagnosticCentersData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function getAllWellnessProgramsAPI() {


    try {
        const response = await adminAPIURL.get('longevityGeneticWellness/getAllPrograms');
        const getAllWellnessProgramsData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('getAllWellnessProgramsData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return getAllWellnessProgramsData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function deleteDiagnosticCenterAPI(requestObj) {


    try {
        const response = await adminAPIURL.post('diagnosticCenter/deleteDiagnosticCenter', requestObj);
        const deleteDiagnosticCenterData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('deleteDiagnosticCenterData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return deleteDiagnosticCenterData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function getWellnessProfessionalsAPI() {


    try {
        const response = await adminAPIURL.get('professionals/getAllProfessionals?searchText=&page=0&size=100');
        const getWellnessProfessionalsData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('getWellnessProfessionalsData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return getWellnessProfessionalsData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function searchDoctorsForWellnessAPI(searchText) {


    try {
        const response = await adminAPIURL.get('doctor/searchDoctorsForWellness?searchText=' + searchText);
        const searchDoctorsForWellnessData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('searchDoctorsForWellnessData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return searchDoctorsForWellnessData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function addProfessionalsAPI(requestObj) {


    try {
        const response = await adminAPIURL.post('professionals/addProfessionals', requestObj);
        const addProfessionalsData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('addProfessionalsData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return addProfessionalsData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function deleteProfessionalByIdAPI(obj) {

    try {
        const response = await adminAPIURL.post('professionals/deleteProfessionalById', obj);
        const deleteProfessionalByIdData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('deleteProfessionalByIdData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return deleteProfessionalByIdData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function getAllUsersAPI(searchText, pageNo, pageSize, phaseNo) {

    try {
        const response = await adminAPIURL.get('userSubscription/getAllUserSubscriptions?searchText=' + searchText + '&pageNo=' + pageNo + '&pageSize=' + pageSize + '&phaseNo=' + phaseNo);
        const getAllUsersData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('getAllUsersData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return getAllUsersData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function getUserSubscriptionsAPI(patientId) {

    try {
        const response = await adminAPIURL.get('userSubscription/getUserSubscriptions?patientId=' + patientId);
        const getUserSubscriptionsData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('getUserSubscriptionsData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return getUserSubscriptionsData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function bookLabTestsAPI(payload) {

    try {
        const response = await labAPIURL.post('genetic/bookLabOrder', payload);
        const bookLabTestsData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('bookLabTestsData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return bookLabTestsData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function getAvailableTimeSlotsAPI(provider, date, clinicId) {

    try {
        const response = await cianacareApi.get('appointment/v2/showAvailableTimeSlots?provider=' + provider + '&date=' + date + '&clinicId=' + clinicId);
        const getAvailableTimeSlotsData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('getAvailableTimeSlotsData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return getAvailableTimeSlotsData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}

export async function bookAppointmentAPI(payload) {

    try {
        const response = await deleteactapis.post('geneticWellness/bookGeneticWellnessAppointment', payload);
        const bookAppointmentData = response.data;

        if (!response.statusText === "OK") {
            throw new Error('bookAppointmentData request failed');
        }


        // Handle the response data
        ////console.log('getVerificationStats successful service', getVerificationStatsDats);
        // debugger;
        return bookAppointmentData;

    } catch (error) {
        //console.error('adminLogin failed:', error);
        throw error;
    }
}
export const getFileByFileIDAPI = async (fileID) => {
    try {
   
        const response = await generateReportUrl.get(`/getFileByFileID?fileID=${fileID}`);

        return response.data;
    } catch (error) {
        throw error;
    }
};


